import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Input} from '@/components/ui/input';

// Keep the editable text separate from the amount sent to the API. In particular,
// clearing a price is not an instruction to make the treatment free.
export const moneyPattern = '[0-9]+([.,][0-9]{1,2})?';
export function minorAmount(text) {
  return new RegExp(`^${moneyPattern}$`).test(text)
    ? Math.round(Number(text.replace(',', '.')) * 100) : null;
}

const MoneyInput = forwardRef(function MoneyInput({value, onValueChange, min, max, ...props}, ref) {
  const [text, setText] = useState(value == null ? '' : String(value / 100));
  const emitted = useRef(value);
  const input = useRef(null);
  useImperativeHandle(ref, () => input.current);
  useEffect(() => {
    const amount = minorAmount(text);
    const below = amount != null && min != null && amount < Math.round(Number(min) * 100);
    const above = amount != null && max != null && amount > Math.round(Number(max) * 100);
    input.current?.setCustomValidity(below ? `Valore minimo: ${min}` : above ? `Valore massimo: ${max}` : '');
  }, [text, min, max]);
  useEffect(() => {
    if (!Object.is(value, emitted.current)) {
      emitted.current = value;
      setText(value == null ? '' : String(value / 100));
    }
  }, [value]);
  return <Input {...props} ref={input} type="text" inputMode="decimal" pattern={moneyPattern}
    value={text} onChange={event => {
      const draft = event.target.value;
      setText(draft);
      emitted.current = minorAmount(draft);
      onValueChange(emitted.current);
    }}/>;
});

export default MoneyInput;
